import { useState } from "react"
import { FormControl, Select, MenuItem, Box, TextField, InputAdornment, ListItemIcon } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import CheckIcon from "@mui/icons-material/Check"

const ProjectSelect = ({ allProjects, selectedProject, handleProjectChange }) => {
  const [searchText, setSearchText] = useState("")
  const [open, setOpen] = useState(false)

  const filteredProjects = allProjects.filter((project) =>
    project.name.toLowerCase().includes(searchText.toLowerCase())
  )

  const handleSearchChange = (event) => {
    setSearchText(event.target.value)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setTimeout(() => setOpen(false), 50)
    setSearchText("")
  }

  const handleProjectChangeAndClearSearchValue = (event) => {
    setSearchText("")
    handleProjectChange(event)
  }

  return (
    <FormControl variant="standard" className="headerProjectSelectContainer">
      {allProjects.length ? (
        <Select
          className="headerProjectSelect"
          value={selectedProject?.id || ""}
          onChange={handleProjectChangeAndClearSearchValue}
          displayEmpty
          open={open}
          onOpen={handleOpen}
          onClose={handleClose}
          MenuProps={{
            disableAutoFocusItem: true,
            autoFocus: false,
            PaperProps: {
              sx: {
                maxWidth: "220px",
                marginTop: "8px",
                marginLeft: "22px"
              },
              onMouseDown: (event) => {
                if (event.target.id === "search-input") {
                  event.stopPropagation()
                }
              },
            },
          }}
          renderValue={() => selectedProject?.name || "Select a project"}
        >
          <MenuItem className="headerProjectSelectSearchItem" disableRipple disableTouchRipple>
            <TextField
              className="headerProjectSearchInput"
              id="search-input"
              variant="standard"
              placeholder="Search..."
              fullWidth
              value={searchText}
              onChange={handleSearchChange}
              autoComplete="off"
              autoFocus
              onKeyDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              onFocus={(e) => e.stopPropagation()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </MenuItem>

          {/* Invisible item with current project for preventing console warning */}
          {selectedProject?.id ? (
            <MenuItem key={1} value={selectedProject.id} sx={{ p: 0 }}></MenuItem>
          ) : (
            <MenuItem value="" disabled>
              Select a project
            </MenuItem>
          )}

          {filteredProjects.length > 0 ? (
            filteredProjects.map((project) => (
              <MenuItem className="headerProjectSelectItem" key={project.id} value={project.id}>
                <Box className="headerProjectSelectItemTitle">
                  {project.name}
                </Box>
                {selectedProject?.id === project.id && (
                  <ListItemIcon className="headerProjectSelectItemTitleIcon">
                    <CheckIcon />
                  </ListItemIcon>
                )}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>No results found</MenuItem>
          )}
        </Select>
      ) : (
        <Box sx={{ width: "192px", height: "32px" }}></Box>
      )}
    </FormControl>
  )
}

export default ProjectSelect
